import type { HistorySubjectIdsOf } from "./types";

// The API and the query keys take the subject as two ids, at most one of them set.
export const historySubjectIdsOf: HistorySubjectIdsOf = (subject) => ({
  floorPlanId: subject?.kind === "plan" ? subject.floorPlanId : null,
  diagramId: subject?.kind === "diagram" ? subject.diagramId : null,
});
